import Vue from "vue";
import axios from "axios";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";

// Without a timeout a stalled backend leaves the UI spinning indefinitely.
// 60s is well past a healthy response and short enough to surface a problem.
axios.defaults.timeout = 60000;

Vue.config.productionTip = false;
Vue.$msalInstance = {};

new Vue({
	router,
	store,
	vuetify,
	render: (h) => h(App),
}).$mount("#app");
